import { render, staticRenderFns } from "./Samson.vue?vue&type=template&id=a54f40c8&scoped=true&"
import script from "./Samson.vue?vue&type=script&lang=js&"
export * from "./Samson.vue?vue&type=script&lang=js&"
import style0 from "./Samson.vue?vue&type=style&index=0&id=a54f40c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54f40c8",
  null
  
)

export default component.exports